import { ContextMessage } from '@/client/features/signals/types';
import { appFetch } from '@/lib/fetch';

export function buildThreadUrl(
  signalId: string,
  params: { length?: string; order?: string; filter?: string[] }
) {
  const parts: string[] = [];
  if (params.length) parts.push(`length=${params.length}`);
  if (params.order) parts.push(`order=${params.order}`);
  (params.filter ?? []).forEach((f) => parts.push(`filter=${f}`));
  return `/api/v0/signals/${signalId}/thread?${parts.join('&')}`;
}

export async function fetchThreadGET(
  signalId: string,
  params: { length?: string; order?: string; filter?: string[] }
) {
  const url = buildThreadUrl(signalId, params);
  const response = await appFetch(url, { method: 'GET' });
  if (!response.ok) throw new Error('Error calling thread endpoint');
  const data = await response.json();
  const list: ContextMessage[] = Array.isArray(data)
    ? data
    : (data.contextMessages ?? data.context_messages ?? []);
  return list;
}
